import {
  DeploymentUnitOutlined,
  EyeOutlined,
  NotificationOutlined,
  SettingOutlined,
  UserOutlined,
} from '@ant-design/icons';
import { SettingsOverlay } from '@app/components/header/components/settingsDropdown/settingsOverlay/SettingsOverlay/SettingsOverlay';
import { AccountSettings } from '@app/components/profile/profileCard/profileFormNav/nav/account/AccountSettings';
import { IntegrationSettings } from '@app/components/profile/profileCard/profileFormNav/nav/IntegrationSettings/IntegrationSettings';
import { Notifications } from '@app/components/profile/profileCard/profileFormNav/nav/notifications/Notifications/Notifications';
import { PersonalInfo } from '@app/components/profile/profileCard/profileFormNav/nav/PersonalInfo/PersonalInfo';
import React from 'react';
import { UserModel } from '@app/domain/UserModel'; // Assuming UserModel defines the type for creditorRole

export interface ProfileNavItem {
  id: number;
  name: string;
  icon: React.ReactNode;
  color: 'primary' | 'error' | 'warning' | 'success';
  children: React.ReactNode;
  href: string;
  disabled: boolean;
}

// Define the base structure separate from the function
const baseNavData = [
  {
    id: 1,
    name: 'profile.nav.personalInfo.title',
    icon: <UserOutlined />,
    color: 'primary' as const, // Use 'as const' for stricter typing if needed
    href: 'personal-info',
    children: <PersonalInfo />,
  },
  {
    id: 2,
    name: 'profile.nav.account.title',
    icon: <SettingOutlined />,
    color: 'primary' as const,
    href: 'account',
    children: <AccountSettings />,
  },
  {
    id: 3,
    name: 'profile.nav.appearanceSettings.title',
    icon: <EyeOutlined />,
    color: 'primary' as const,
    href: 'appearance',
    children: <SettingsOverlay />,
  },
  {
    id: 4,
    name: 'profile.nav.integrationSettings.title',
    icon: <DeploymentUnitOutlined />,
    color: 'primary' as const,
    href: 'integration-settings',
    children: <IntegrationSettings />,
  },
  {
    id: 5,
    name: 'profile.nav.notifications.title',
    icon: <NotificationOutlined />,
    color: 'primary' as const,
    href: 'notification',
    children: <Notifications />,
  },
];

export const getProfileNavData = (creditorRole: UserModel['creditorRole']): ProfileNavItem[] => {
  const isAdminOrNull = creditorRole === null || creditorRole === 'CreditorAdmin';
  const isAccoutOwner = !creditorRole;

  return baseNavData.map((item) => ({
    ...item,
    disabled: ['personal-info', 'appearance'].includes(item.href)
      ? false
      : item.href === 'account'
      ? !isAdminOrNull
      : !isAccoutOwner,
  }));
};
